(function () {
  'use strict';

  const selectors = {
    pin: '.hotspot-pin',
    trigger: '.hotspot-trigger',
    popup: '.hotspot-popup',
    close: '.hotspot-popup-close',
  };

  const activeClass = 'is-active';

  function setPopupState(pin, isOpen) {
    const trigger = pin.querySelector(selectors.trigger);
    const popup = pin.querySelector(selectors.popup);

    if (!trigger || !popup) return;

    pin.classList.toggle(activeClass, isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    popup.setAttribute('aria-hidden', String(!isOpen));

    const section = pin.closest('.custom-shop-the-look');
    if (section) {
      section.classList.toggle('has-active-hotspot', Boolean(section.querySelector(`${selectors.pin}.${activeClass}`)));
    }
  }

  function closeAllPopups() {
    document.querySelectorAll(`${selectors.pin}.${activeClass}`).forEach((pin) => {
      setPopupState(pin, false);
    });
  }

  function repositionPopup(popup) {
    popup.style.removeProperty('left');
    popup.style.removeProperty('right');
    popup.style.removeProperty('top');
    popup.style.removeProperty('bottom');
    popup.style.removeProperty('transform');

    requestAnimationFrame(() => {
      const rect = popup.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      if (rect.right > viewportWidth - 16) {
        const overflowRight = rect.right - (viewportWidth - 16);
        popup.style.transform = `translate(calc(-50% - ${overflowRight}px), 0)`;
      } else if (rect.left < 16) {
        const overflowLeft = 16 - rect.left;
        popup.style.transform = `translate(calc(-50% + ${overflowLeft}px), 0)`;
      }

      if (rect.top < 16) {
        popup.style.top = 'calc(100% + 1.6rem)';
        popup.style.bottom = 'auto';
      } else if (rect.bottom > viewportHeight - 16) {
        popup.style.top = 'auto';
        popup.style.bottom = 'calc(100% + 1.6rem)';
      }
    });
  }

  function togglePopup(pin) {
    const popup = pin.querySelector(selectors.popup);
    if (!popup) return;

    const isOpen = pin.classList.contains(activeClass);
    closeAllPopups();

    if (!isOpen) {
      setPopupState(pin, true);
      repositionPopup(popup);
    }
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest(selectors.close);
    const trigger = event.target.closest(selectors.trigger);

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeAllPopups();
      return;
    }

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      togglePopup(trigger.closest(selectors.pin));
      return;
    }

    if (!event.target.closest(selectors.popup)) {
      closeAllPopups();
    }
  });

  document.addEventListener('pointerover', (event) => {
    const pin = event.target.closest(selectors.pin);
    if (!pin || (event.relatedTarget && pin.contains(event.relatedTarget))) return;

    const popup = pin.querySelector(selectors.popup);
    if (popup) repositionPopup(popup);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(selectors.trigger);

    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      togglePopup(trigger.closest(selectors.pin));
    }

    if (event.key === 'Escape') {
      closeAllPopups();
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(`${selectors.pin}.${activeClass} ${selectors.popup}`).forEach(repositionPopup);
  });
})();
